import Lookup from 'src/componentes/select2';

const GrupoEmail = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/GrupoEmailLookup"
      {...props}
    />
  );
};

export default GrupoEmail;
